/* Complete the look — totals, the discount ladder, the colour swap, one add.
 *
 * Lived inline in sections/vg-bundle.liquid until 01/11. It moved out when the
 * colour swap was added: the section was getting long, and this file is the
 * same on every product page, so the browser caches it once instead of parsing
 * it again on each one.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-set]');
  if (!root) return;

  var symbol = root.getAttribute('data-symbol') || '$';
  var note = root.querySelector('[data-set-note]');
  var badge = root.querySelector('[data-set-badge]');
  var was = root.querySelector('[data-set-was]');
  var now = root.querySelector('[data-set-now]');
  var addBtn = root.querySelector('[data-set-add]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-set-card]'));

  /* "2:15,3:25" -> [{q:2,d:15},{q:3,d:25}], smallest first. */
  var tiers = (root.getAttribute('data-ladder') || '')
    .split(',')
    .map(function (part) {
      var bits = part.split(':');
      return { q: parseInt(bits[0], 10), d: parseFloat(bits[1]) };
    })
    .filter(function (t) { return t.q > 0 && t.d > 0; })
    .sort(function (a, b) { return a.q - b.q; });

  function money(cents) {
    var n = (cents / 100).toFixed(2).split('.');
    return symbol + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1];
  }

  function priceOf(card) {
    var sel = card.querySelector('[data-set-select]');
    if (!sel) return 0;
    var opt = sel.options[sel.selectedIndex];
    return opt ? parseInt(opt.getAttribute('data-price') || '0', 10) : 0;
  }

  function live() {
    return cards.filter(function (c) { return c.getAttribute('data-on') === 'true'; });
  }

  function render() {
    var on = live();
    var sum = 0;
    on.forEach(function (c) { sum += priceOf(c); });

    var off = 0;
    tiers.forEach(function (t) { if (on.length >= t.q) off = t.d; });

    var total = Math.round((sum * (100 - off)) / 100);

    now.textContent = money(total);
    if (off > 0 && total < sum) {
      was.hidden = false;
      was.textContent = money(sum);
      badge.hidden = false;
      badge.textContent = (root.getAttribute('data-badge') || 'Save {n}% with the set')
        .replace('{n}', String(off));
    } else {
      was.hidden = true;
      badge.hidden = true;
    }
    addBtn.disabled = on.length === 0;
  }

  /* ------------------------------------------------------------- colour swap
   * Two stacked photos per card, one in front. A colour change loads the new
   * photo into the one at the back, waits for it to DECODE, and only then
   * brings it forward — so the fade never runs over a half-drawn image and
   * never shows an empty frame. Nothing animates until the bytes are there.
   *
   * It fires on colour, not on variant: green/M to green/L is the same photo,
   * so the card must hold still. That is what data-color on the card tracks.
   */
  cards.forEach(function (card) {
    var map = {};
    var opts = Array.prototype.slice.call(card.querySelectorAll('[data-set-select] option[data-img]'));
    opts.forEach(function (o) {
      var key = o.getAttribute('data-color') || '';
      if (key && !map[key]) map[key] = o.getAttribute('data-img');
    });
    card.vgImgs = map;
  });

  function swap(card, url) {
    var layers = Array.prototype.slice.call(card.querySelectorAll('[data-set-layer]'));
    if (layers.length < 2 || !url) return;

    var front = card.getAttribute('data-front') === 'b' ? layers[1] : layers[0];
    var back = front === layers[0] ? layers[1] : layers[0];
    if (back.getAttribute('src') === url) return;

    /* srcset would win over the src we are about to set. */
    back.removeAttribute('srcset');
    back.setAttribute('src', url);

    var bring = function () {
      back.classList.add('is-front');
      front.classList.remove('is-front');
      card.setAttribute('data-front', back === layers[1] ? 'b' : 'a');
    };

    if (back.decode) {
      back.decode().then(bring).catch(bring);
    } else {
      back.onload = bring;
      back.onerror = bring;
    }
  }

  root.addEventListener('change', function (e) {
    if (!e.target.matches('[data-set-select]')) return;
    var card = e.target.closest('[data-set-card]');
    card.classList.remove('is-missing');

    var opt = e.target.options[e.target.selectedIndex];
    var colour = opt ? opt.getAttribute('data-color') || '' : '';
    if (colour && colour !== card.getAttribute('data-color')) {
      card.setAttribute('data-color', colour);
      swap(card, card.vgImgs[colour]);
    }

    render();
  });

  root.addEventListener('click', function (e) {
    var x = e.target.closest('[data-set-x]');
    if (!x) return;
    var card = x.closest('[data-set-card]');
    var on = card.getAttribute('data-on') !== 'true';
    card.setAttribute('data-on', on ? 'true' : 'false');
    card.classList.toggle('is-off', !on);
    x.setAttribute('aria-pressed', on ? 'true' : 'false');
    x.setAttribute('aria-label', (on ? 'Remove ' : 'Put back ') + card.querySelector('.setcard__name').textContent.trim());
    render();
  });

  addBtn.addEventListener('click', function () {
    var items = [];
    var missing = null;
    live().forEach(function (card) {
      var sel = card.querySelector('[data-set-select]');
      if (!sel || !sel.value) {
        card.classList.add('is-missing');
        if (!missing) missing = card;
        return;
      }
      card.classList.remove('is-missing');
      items.push({ id: Number(sel.value), quantity: 1 });
    });

    if (missing) {
      note.textContent = root.getAttribute('data-msg-size');
      var sel = missing.querySelector('[data-set-select]');
      if (sel) sel.focus();
      return;
    }
    if (!items.length) return;

    var label = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        window.location.href = (rootUrl + 'cart').replace('//', '/');
      })
      .catch(function () {
        addBtn.disabled = false;
        addBtn.textContent = label;
        note.textContent = root.getAttribute('data-msg-fail');
      });
  });

  render();
})();
